import React, { useRef, useState } from 'react'

import { thousandSeparator } from '../../utils/helpers'

const TotalCommissionListing = ({
  filterData,
  entities,
  handleClick
}) => {
  const divRef = useRef(null)
  const [filteredData, setFilteredData] = useState(entities || [])

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ]

  return (
    <>
      <div className='header'>
        <p className='title-fix'>{ filterData.DateYear } Completed Sales Commission By Monthly - { filterData.BranchName }</p>
      </div>

      <div className='lists-wrapper md:h-auto h-[56px]'>
        <div ref={ divRef } className='scrollable'>
          <div className='lists'>
            {
              filteredData?.map((data, index) => (
                <div
                  key={ index }
                  onClick={ () => handleClick(data) }
                  className='list group'
                >
                  <p className='branch-name text-gray-two group-hover:text-primary'>{ monthNames[data.Month - 1] }</p>

                  <p className='commission text-gray-one group-hover:text-primary'>
                    RM { data?.CommissionTotalSum ? thousandSeparator(data?.CommissionTotalSum) : 0 }
                  </p>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default TotalCommissionListing